import React from 'react'

function index() {
  return (
    <div>Input Data</div>
  )
}

export default index